/**
 * The id of a step, an objective or a condition, struck by the EDITOR (refonte
 * modulaire §7.1, §8.6).
 *
 * A jump aims at a step's id and never at its rank, a trigger names an
 * objective by its id, a variable stores `{{objectif:id}}`: all three survive a
 * reorder and a rename because the id is minted once, here, and never derived
 * from a position or a name. The server only checks it is unique inside one
 * content (`protocolContentSchema`).
 *
 * `crypto.randomUUID` is what every browser this app runs in has, and what the
 * criterion store uses server side for its own ids - one shape of id on both
 * sides, so nothing ever has to tell them apart.
 */
export function newLocalId(): string {
  return crypto.randomUUID();
}
